import { Label } from '@/components/ListView/Label';
import { useTranslation } from '@/i18n';
import { Bottom, ListView, Top } from '@moneyforward/ap-frontend-components';
import classNames from 'classnames';
import { FC, memo } from 'react';

import styles from './Top.module.scss';

const cx = classNames.bind(styles);

export type DetailTopViewProps = {
  label: string;
  visibility: boolean;
  is_required: boolean;
  tooltip_message: string;
  isFlexibleValidationEnabled: boolean;
};

const leftRightRatio = {
  left: {
    max: '160px',
    min: '160px',
  },
  right: {},
};

export const DetailTopView: FC<DetailTopViewProps> = memo(
  ({
    label,
    visibility,
    is_required,
    tooltip_message,
    isFlexibleValidationEnabled,
  }) => {
    const { t } = useTranslation();
    return (
      <ListView leftRightRatio={leftRightRatio}>
        <Top>
          <Label>{t('transaction_items.table.label')}</Label>
          <div className={cx(styles['label'])}>{label}</div>
        </Top>
        <Top>
          <Label>{t('transaction_items.table.is_visible')}</Label>
          <div>
            {visibility
              ? t('transaction_items.table.visible')
              : t('transaction_items.table.invisible')}
          </div>
        </Top>
        {isFlexibleValidationEnabled && (
          <Top>
            <Label>{t('transaction_items.drawer.is_required')}</Label>
            <div>
              {is_required
                ? t('transaction_items.drawer.is_required.true')
                : t('transaction_items.drawer.is_required.false')}
            </div>
          </Top>
        )}
        <Bottom>
          <Label> {t('transaction_items.table.tooltip_message')}</Label>
          <div className={cx(styles['value-container'])}>{tooltip_message}</div>
        </Bottom>
      </ListView>
    );
  }
);
DetailTopView.displayName = 'DetailTopView';
